import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { SiteHeader } from './components/SiteHeader';
import { SiteFooter } from './components/SiteFooter';
import { ScrollManager } from './components/ScrollManager';
import { Home } from './pages/Home';
import { Products } from './pages/Products';
import { PropFlow } from './pages/PropFlow';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2rikrdguv4vgt">
      <ScrollManager data-id="element-1" data-mp="2mmceka451ect" />
      <div className="flex min-h-screen w-full flex-col bg-white font-sans text-ink-900" data-id="element-2" data-mp="2mmvjmq8ow89f">
        <SiteHeader data-id="element-3" data-mp="31ayq00qn9lyr" />
        <main className="flex-1" data-id="element-4" data-mp="31c9vc4zqn1rz">
          <Routes data-id="element-5" data-mp="31cjp83nwlt2y">
            <Route path="/" element={<Home data-id="element-7" data-mp="2wiyx2s8zrtbo" />} data-id="element-6" data-mp="2wka02pum4x1q" />
            <Route path="/products" element={<Products data-id="element-9" data-mp="28ufpkexrnkkn" />} data-id="element-8" data-mp="2wifhhi6tdh0t" />
            <Route path="/propflow" element={<PropFlow data-id="element-11" data-mp="28sutulzptvl7" />} data-id="element-10" data-mp="28tw972nrl48q" />
            <Route path="/about" element={<About data-id="element-13" data-mp="23vuokdaowwv5" />} data-id="element-12" data-mp="28s2y9b64bxux" />
            <Route path="/contact" element={<Contact data-id="element-15" data-mp="23v2u55stx56g" />} data-id="element-14" data-mp="23u9vyt7xrnzx" />
            <Route path="*" element={<Home data-id="element-17" data-mp="3ikr0s4yore8d" />} data-id="element-16" data-mp="3ijxoypkvdyjd" />
          </Routes>
        </main>
        <SiteFooter data-id="element-18" data-mp="3ihuyy5jpw5en" />
      </div>
    </BrowserRouter>;
}